import { useEffect, useRef } from 'react';
import { motion, useSpring, useTransform } from 'framer-motion';

interface AnimatedNumberProps {
  value: number;
  decimals?: number;
  className?: string;
}

export function AnimatedNumber({
  value,
  decimals = 0,
  className
}: AnimatedNumberProps) {
  const spring = useSpring(value, {
    duration: 1000,
    bounce: 0
  });

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      // Set immediately on first render, no animation
      spring.set(value);
      isFirstRender.current = false;
    } else {
      // Animate on subsequent updates
      spring.set(value);
    }
  }, [value, spring]);

  const display = useTransform(spring, (latest) =>
    latest.toFixed(decimals)
  );

  return (
    <motion.span className={className}>
      {display}
    </motion.span>
  );
}
